import React, {Component} from 'react'
import {connect} from 'react-redux'
import Loader from 'react-loaders'
// REDUX ACTIONS
import {withRouter, Link} from "react-router-dom";

/*** REACT TOOLBOX ***/
import List from 'react-toolbox/lib/list/List'
import ListItem from 'react-toolbox/lib/list/ListItem'
import IconButton from 'react-toolbox/lib/button/IconButton'
import ListSubHeader from 'react-toolbox/lib/list/ListSubHeader'
import ListDivider from 'react-toolbox/lib/list/ListDivider'

import './NodeList.css'
import './NodeList.scss'

const tableNames = ["Identifier", "MAC", "Position", "Status", "Firmware.v", "Hardware.v", "Last Activity"];
const order_icons = ["unfold_more", "expand_less", "expand_more"];

const url_graph = (node) => `http://chronograf.bettair/sources/2/chronograf/data-explorer?query=SELECT%20mean%28%22SN_4_WE%22%29%20AS%20%22mean_SN_4_WE%22%2C%20mean%28%22SN_3_WE%22%29%20AS%20%22mean_SN_3_WE%22%2C%20mean%28%22SN_2_WE%22%29%20AS%20%22mean_SN_2_WE%22%2C%20mean%28%22SN_1_WE%22%29%20AS%20%22mean_SN_1_WE%22%2C%20mean%28%22PM_2P5%22%29%20AS%20%22mean_PM_2P5%22%2C%20mean%28%22PM_10%22%29%20AS%20%22mean_PM_10%22%2C%20mean%28%22PM_1%22%29%20AS%20%22mean_PM_1%22%20FROM%20%22BettAir%22.%22autogen%22.%22rawData%22%20WHERE%20time%20%3E%20:dashboardTime:%20AND%20%22DEVICE_ID%22%3D%27${node}%27%20GROUP%20BY%20time%285s%29%20FILL%280%29`;

// const test_conn = () => {
//
//     return new Promise((resolver, reject) => {
//         let request = new XMLHttpRequest();
//
//         request.open('GET', 'http://10.8.0.5:2323', true);
//         request.withCredentials = true;
//
//         request.onerror = () => reject();
//
//         request.onreadystatechange = () => {
//             if (request.readyState === 4) {
//                 if (request.status >= 200 && request.status < 400)
//                     resolver();
//                 else
//                     reject();
//             }
//         };
//
//         request.send();
//     });
// };

const createNodeInf = (entity) => {
    let last = new Date(entity.lastActivity.value);
    let diff = new Date() - last;
    let classState = 'timeKo';

    if (diff < 1200000)
        classState = 'timeOk';
    else if (diff < 86400000)
        classState = 'timeWarn';

    return (<div className={'nodeListItem'}>
        <span className={'nodeListItemInfo'}> {entity.id}</span>
        <span className={'nodeListItemInfo small'}> {entity.generalInfo.value.SENSOR_ID}</span>
        <span className={'nodeListItemInfo small'}> {entity.generalInfo.value.POSITION}</span>
        <span className={'nodeListItemInfo small'}> {entity.generalInfo.value.STATUS}</span>
        <span className={'nodeListItemInfo small'}> {entity.generalInfo.value.F_V}</span>
        <span className={'nodeListItemInfo small'}> {entity.generalInfo.value.H_V}</span>
        <span className={`nodeListItemInfo small ${classState}`}> {last.toLocaleString()}</span>
    </div>)
};


class NodeList extends Component {

    handleRenderSensors(chronos) {

        let order = [];

        if (this.props.order.active) {

            let aux = [];

            aux = aux.concat(this.props.sensors.list);

            let index = this.props.order.status.indexOf(1);

            if (index === -1)
                index = this.props.order.status.indexOf(2) + 7;

            switch (index % 7) {
                case 0:
                    order = aux.sort((x, y) => {
                        return ('' + x.id).localeCompare(y.id);
                    });
                    break;

                case 1:
                    order = aux.sort((x, y) => {
                        return ('' + x.generalInfo.value.SENSOR_ID).localeCompare(y.generalInfo.value.SENSOR_ID);
                    });
                    break;

                case 2:
                    order = aux.sort((x, y) => {
                        return ('' + x.generalInfo.value.POSITION).localeCompare(y.generalInfo.value.POSITION);
                    });
                    break;

                case 3:
                    order = aux.sort((x, y) => {
                        return ('' + x.generalInfo.value.STATUS).localeCompare(y.generalInfo.value.STATUS);
                    });
                    break;

                case 4:
                    order = aux.sort((x, y) => {
                        return ('' + x.generalInfo.value.F_V).localeCompare(y.generalInfo.value.F_V);
                    });
                    break;

                case 5:
                    order = aux.sort((x, y) => {
                        return ('' + x.generalInfo.value.H_V).localeCompare(y.generalInfo.value.H_V);
                    });
                    break;

                case 6:
                    order = aux.sort((x, y) => {
                        let timex = new Date(x.lastActivity.value);
                        let timey = new Date(y.lastActivity.value);

                        if (isNaN(timex.getTime()))
                            return 1;
                        else if (isNaN(timey.getTime()))
                            return -1;
                        else if (timex < timey)
                            return -1;
                        else if (timex > timey)
                            return 1;
                        else
                            return 0;
                    });
                    break;

                default:
                    break;
            }

            if (index > 6)
                order = order.reverse();
        } else {
            order = order.concat(this.props.sensors.list);
        }

        return order.slice(this.props.pag, this.props.pag + 20).map((entity, key) => {
            return (
                <ListItem
                    key={key}
                    caption={entity.id}
                    itemContent={createNodeInf(entity)}
                    rightActions={[
                        <Link to={"/admin/nodes/detail/" + entity.id} key={key}><IconButton
                            key={key}
                            icon='info'
                            primary
                        /></Link>,
                        <a target={"_blank"} href={url_graph(entity.id)} key={key}>
                            <IconButton
                                icon="insert_chart"
                                primary
                                disabled={!chronos}
                            />
                        </a>]}
                />
            )
        })
    }

    handleSensorsPage(direction) {
        this.props.handlePage(direction, this.props.sensors.count);
    }

    render() {

        let chronos = true;
        //
        // test_conn().then(() => chronos = true).catch(() => chronos = false);

        return (
            <div className=" col-xs-12 nodeContent">
                <div className="nodeListContainer">
                    <div className="listHeader">
                        <ListSubHeader className="listSubheader" caption="Current Nodes"/>
                        <Link to={'/admin/nodes/detail/new'}><IconButton accent
                                                                         className="listHeaderButton"
                                                                         icon="add"/>
                        </Link>
                    </div>
                    <div className={'listFieldContainer'}>
                        {tableNames.map((field, index) => {
                            return (<span key={index} style={field === 'd' ? {"marginLeft": "2%"} : {}}
                                          className={'listField'}> {field} <IconButton
                                key={index}
                                icon={order_icons[this.props.order.status[index]]}
                                primary
                                onClick={() => this.props.handleOrder(index)}
                            /></span>)
                        })}
                    </div>
                    <ListDivider/>
                    <List ripple className={'nodeList noCheckBox'}>
                        {this.props.sensors.count > 0 ? this.handleRenderSensors(chronos) :
                            <Loader type="ball-pulse" true/>}
                        {this.props.sensors.count > 19 && <ListDivider/>}
                        {this.props.sensors.count > 19 && <ListItem key={'Paginator'}
                                                                    rightActions={[
                                                                        <IconButton
                                                                            key={'Paginator'}
                                                                            icon='keyboard_arrow_left'
                                                                            primary
                                                                            onClick={this.handleSensorsPage.bind(this, "previous")}
                                                                        />,
                                                                        <IconButton
                                                                            key={'Paginator'}
                                                                            icon="keyboard_arrow_right"
                                                                            primary
                                                                            onClick={this.handleSensorsPage.bind(this, "next")}
                                                                        />
                                                                    ]}
                        />}
                    </List>
                </div>
            </div>
        )
    }

}


const sensorListStateToProps = (state) => {
    return {
        sensors: state.devices,
    }
};

export default withRouter(connect(sensorListStateToProps, null)(NodeList))



// WEBPACK FOOTER //
// ./src/components/DashBoard/AdminNodes/NodeList/NodeList.js